/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_ProviderInputs */

const cs_settings_calendar_provider = /** @type {(inputs: Settings_Calendar_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poskytovatel`)
};

const en_settings_calendar_provider = /** @type {(inputs: Settings_Calendar_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider`)
};

/**
* | output |
* | --- |
* | "Provider" |
*
* @param {Settings_Calendar_ProviderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_provider = /** @type {((inputs?: Settings_Calendar_ProviderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_ProviderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_provider(inputs)
	return cs_settings_calendar_provider(inputs)
});